import React, { useContext, useEffect, useState } from "react";
import { classesURL, sessionsClassesURL } from "../../Hooks/URL";
import useFetch from "../../Hooks/useFetch";
import { useNavigate, useParams } from "react-router-dom";
import ClassSessions from "../../Templates/Sessions/ClassSessions/ClassSessions";
import { userContext } from "../../Contexts/userContext";

function ClassSessionsPage() {
  let { id } = useParams();
  const navigate = useNavigate();
  const { contextData, setContextData } = useContext(userContext);
  const ClassUrl = `${classesURL}/${id}`;
  const url = `${sessionsClassesURL(id)}`;

  const [sessionsOpen, setSessionsOpen] = useState(false);

  const [sessions, setSessions] = useState([]);
  const [Class, setClass] = useState(null);
  const {
    data: classData,
    loading: classLoading,
    error: classError,
  } = useFetch(ClassUrl);
  const { data, loading, error } = useFetch(url);

  useEffect(() => {
    if (!loading && !error && data) {
      setSessions(data.data);
    }
  }, [data, loading, error]);

  useEffect(() => {
    if (!classLoading && !classError && classData) {
      setClass(classData.data);
    }
  }, [classData, classLoading, classError]);

  useEffect(() => {
    setContextData({ ...contextData, page: "classes", data: Class?.className });
  }, [Class]);

  return (
    <ClassSessions
      Class={Class}
      sessions={sessions}
      loading={loading}
      sessionsOpen={sessionsOpen}
      setSessionsOpen={setSessionsOpen}
      url={url}
      setSessions={setSessions}
    />
  );
}

export default ClassSessionsPage;
